export default {
  regionSelector: {
    chooseADisasterRegion: 'Seleziona una regione del disastro',
    lastUpdate: 'Ultimo aggiornamento'
  }
}
